import React, { useEffect, useRef, useState } from "react";
import * as styles from "./PortaFiltro.module.scss";
import SliderArrowLeft from "../../../icons/arrows/slider-arrow-left.svg";
import SliderArrowRight from "../../../icons/arrows/slider-arrow-right.svg";
import img_filtro from "../../../images/cafe_partes_03.png";
import img_filtro1 from "../../../images/filtro1.png";
import img_filtro2 from "../../../images/filtro2.png";
import img_filtro3 from "../../../images/filtro3.png";
import ReusableItemDesc from "../../Products/Etermo/ItemDescription/ItemDescription";
import line1 from "../../../images/line1.svg";
import line5 from "../../../images/line5.svg";
import { motion } from "framer-motion";

const PortaFiltro = () => {
  const ref = useRef(null);
  const sectionsRef = useRef([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);

  const handleScroll = (e) => {
    if (ref.current) {
      const currentScrollLeft = ref.current.scrollLeft;
      const sections = sectionsRef.current;

      const isAtStart = currentScrollLeft === 0;
      const isAtEnd =
        currentScrollLeft + ref.current.offsetWidth >= ref.current.scrollWidth;

      // Si estamos en la primera sección y hacemos scroll hacia arriba, permitir el scroll vertical
      if (isAtStart && e.deltaY < 0) {
        return;
      }

      // Si estamos en la última sección y hacemos scroll hacia abajo, permitir el scroll vertical
      if (isAtEnd && e.deltaY > 0) {
        return;
      }

      // Prevenir el comportamiento predeterminado para manejar el scroll horizontal
      e.preventDefault();

      // Lógica para moverse entre secciones
      let targetSectionIndex = -1;

      if (e.deltaY > 0) {
        targetSectionIndex = sections.findIndex(
          (section) => section.offsetLeft - 1 > currentScrollLeft
        );
      } else {
        targetSectionIndex = sections.findIndex(
          (section) => section.offsetLeft + 1 >= currentScrollLeft
        );
        if (targetSectionIndex !== -1) {
          targetSectionIndex -= 1;
        }
      }

      if (targetSectionIndex === -1) {
        targetSectionIndex = e.deltaY > 0 ? sections.length - 1 : 0;
      }

      if (targetSectionIndex >= 0 && targetSectionIndex < sections.length) {
        const targetSection = sections[targetSectionIndex];
        ref.current.scrollTo({
          left: targetSection.offsetLeft,
          behavior: "smooth",
        });
      }

      // Actualizar la visibilidad de los botones
      setShowPreviousButton(!isAtStart);
      setShowNextButton(!isAtEnd);
    }
  };

  useEffect(() => {
    const ulElement = ref.current;

    if (ulElement) {
      ulElement.addEventListener("wheel", handleScroll, { passive: false });
    }

    return () => {
      if (ulElement) {
        ulElement.removeEventListener("wheel", handleScroll);
      }
    };
  }, []);

  const goToNextSection = () => {
    const currentScrollLeft = ref.current.scrollLeft;
    const sections = sectionsRef.current;
    const nextSectionIndex = sections.findIndex(
      (section) => section.offsetLeft > currentScrollLeft
    );
    if (nextSectionIndex !== -1) {
      ref.current.scrollTo({
        left: sections[nextSectionIndex].offsetLeft,
        behavior: "smooth",
      });
    }

    const isLastSection = nextSectionIndex >= sections.length - 1;
    setShowNextButton(!isLastSection);

    // Mostrar siempre el botón Anterior al avanzar
    setShowPreviousButton(true);
  };

  const goToPreviousSection = () => {
    const currentScrollLeft = ref.current.scrollLeft;
    const sections = sectionsRef.current;

    // Buscamos la sección actualmente en foco
    const currentSectionIndex = sections.findIndex(
      (section, index) =>
        currentScrollLeft >= section.offsetLeft &&
        (index === sections.length - 1 ||
          currentScrollLeft < sections[index + 1].offsetLeft)
    );

    // Determinamos si hay una sección anterior
    const previousSectionIndex =
      currentSectionIndex > 0 ? currentSectionIndex - 1 : -1;

    if (previousSectionIndex !== -1) {
      ref.current.scrollTo({
        left: sections[previousSectionIndex].offsetLeft,
        behavior: "smooth",
      });
    }

    const isFirstSection = previousSectionIndex <= 0;
    setShowPreviousButton(!isFirstSection);

    // Mostrar siempre el botón Siguiente al retroceder
    setShowNextButton(true);
  };

  return (
    <section className={styles.container_section}>
      <button
        onClick={goToPreviousSection}
        className={styles.previousButton}
        style={{ display: showPreviousButton ? "block" : "none" }}
      >
        <img src={SliderArrowLeft} alt="boton izquierda" />
      </button>
      <button
        onClick={goToNextSection}
        className={styles.nextButton}
        style={{ display: showNextButton ? "block" : "none" }}
      >
        <img src={SliderArrowRight} alt="boton derecha" />
      </button>

      <ul ref={ref}>
        <li ref={(el) => (sectionsRef.current[0] = el)}>
          <section
            className={`${styles.children_section} ${styles.backgraund}`}
          >
            <div className={styles.container_inf}>
              <h4>Accesorios</h4>
              <h2>Tipos de Portafiltros</h2>

              <div className={styles.container_img}>
                <img src={img_filtro} alt="filtros" />

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.img_item}
                >
                  <div className={styles.Line}>
                    <img src={line1} alt="line1" />
                  </div>

                  <ReusableItemDesc
                    title="Porta filtro "
                    description="Para filtro de cápsulas
                    Nespresso®"
                    textColor="black"
                  />
                </motion.div>

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.img_item2}
                >
                  <div className={styles.Line}>
                    <img src={line1} alt="line1" />
                  </div>

                  <ReusableItemDesc
                    title="Porta Filtro Grande"
                    description="Para filtro simple y doble"
                    textColor="black"
                  />
                </motion.div>
              </div>
            </div>
          </section>
        </li>
        <li ref={(el) => (sectionsRef.current[1] = el)}>
          <section className={styles.children_section}>
            <div className={styles.container_inf}>
              <h4>Accesorios</h4>
              <h2>Tipos de Filtros</h2>

              <div className={styles.container_img2}>
                <div className={styles.container_filtros}>
                  <img src={img_filtro1} alt="filtros" />
                  <img src={img_filtro2} alt="filtros1" />
                  <img src={img_filtro3} alt="filtros2" />
                </div>

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.img_item}
                >
                  <img src={line5} alt="line1" />

                  <ReusableItemDesc
                    title="Filtro para 
                    cápsulas
                    Nespresso®"
                    textColor="black"
                  />
                </motion.div>

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.img_item2}
                >
                  <img src={line5} alt="line1" />

                  <ReusableItemDesc
                    title="Filtro doble"
                    description="Para lograr un espresso doble y también una taza grande de 
                    Capuccino y Latte"
                    textColor="black"
                  />
                </motion.div>

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                  className={styles.img_item3}
                >
                  <img src={line5} alt="line1" />

                  <ReusableItemDesc
                    title="Filtro simple"
                    description="Para lograr un espresso simple y también una pequeña taza de 
                    Capuccino y Latte"
                    textColor="black"
                  />
                </motion.div>
              </div>
            </div>
          </section>
        </li>
      </ul>
    </section>
  );
};

export default PortaFiltro;
